import { render } from "./Search.vue?vue&type=template&id=b1d913d8&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=b1d913d8&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d913d8"]])

export default __exports__